import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errorCode, errorText } from "../lib/api";

export const CandleDialog = ({ open, onOpenChange, slug, name, onLit }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/memorials/${slug}/candles`, { message, website });
      toast.success(t("candle.lit"));
      setMessage("");
      onLit?.(data.count, data.candle);
      onOpenChange(false);
    } catch (err) {
      if (errorCode(err) === "candle_already_lit") toast(t("candle.already"));
      else toast.error(errorText(t, err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="candle-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-normal">{t("candle.title", { name })}</DialogTitle>
          <DialogDescription>{t("candle.text")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          <label htmlFor="candle-message" className="text-sm font-semibold">{t("candle.message")}</label>
          <textarea id="candle-message" dir="auto" maxLength={80} rows={2} value={message} onChange={(e) => setMessage(e.target.value)} placeholder={t("candle.placeholder")} className="field-input resize-none" data-testid="candle-message-input" />
          <p className="text-xs text-end text-[hsl(var(--muted-foreground))]" data-testid="candle-message-counter">{message.length}/80</p>
          <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={website} onChange={(e) => setWebsite(e.target.value)} />
          <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="candle-submit-btn"><Flame size={16} /> {t("candle.submit")}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
